import React from 'react';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../../shared/ui/page-header/page-header.jsx';
import FloatingAlerts from '../../../shared/ui/floating-alerts/floating-alerts.jsx';
import LoadingContainer from '../../../shared/ui/loading-container/loading-container.jsx';

function SystemTradingPlatformsPageView({
  rows,
  isLoading,
  isSaving,
  error,
  success,
  onAliasChange,
  saveAlias,
}) {
  const { t } = useTranslation();
  return (
    <div>
      <FloatingAlerts
        info={isSaving ? t('tradingPlatforms.savingInfo') : ''}
        error={error}
        success={success}
      />
      <PageHeader title={t('tradingPlatforms.title')} subtitle={t('tradingPlatforms.subtitle')} />

      <div className="widget-content searchable-container list">
        <div className="card card-body">
          <LoadingContainer isLoading={isLoading} hasData={rows.length > 0}>
              <table className="table search-table align-middle text-nowrap mb-0">
                <thead className="header-item">
                  <tr>
                    <th style={{ width: '160px' }}>{t('tradingPlatforms.colPlatform')}</th>
                    <th>{t('tradingPlatforms.colLabel')}</th>
                    <th>{t('tradingPlatforms.colAlias')}</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.length === 0 ? (
                    <tr>
                      <td colSpan="3" className="text-center text-muted">{t('tradingPlatforms.noTradingPlatformsFound')}</td>
                    </tr>
                  ) : null}

                  {rows.map((row) => (
                    <tr key={row.platform}>
                      <td>{row.platformLabel}</td>
                      <td>{row.label}</td>
                      <td>
                        <input
                          className="form-control form-control-sm"
                          value={row.draftAlias}
                          onChange={(event) => onAliasChange(row.platform, event.target.value)}
                          onBlur={() => saveAlias(row.platform)}
                          onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                              event.preventDefault();
                              event.currentTarget.blur();
                            }
                          }}
                          placeholder={t('tradingPlatforms.aliasPlaceholder')}
                          disabled={isSaving}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
          </LoadingContainer>
        </div>
      </div>
    </div>
  );
}

export default SystemTradingPlatformsPageView;
